import { SynchronizedTime } from '@exodus/basic-utils';
export async function synchronizeTime(fetch) {
    const preTime = SynchronizedTime.now();
    const response = await fetch();
    const postTime = SynchronizedTime.now();
    const dateHeader = response.headers.get('Date');
    if (dateHeader) {
        const serverTime = Date.parse(dateHeader).valueOf();
        if (!Number.isNaN(serverTime))
            SynchronizedTime.update({ preTime, postTime, serverTime });
    }
    return response;
}
export function isFreezable(val) {
    return !!val && typeof val === 'object';
}
